import { useMutation } from '@tanstack/react-query';

import { downloadManifestForDeparture } from '~/services/ToursService';

interface DownloadManifestVariables {
  tourId: string;
  departureName: string;
}

export function useDownloadManifest() {
  return useMutation({
    mutationFn: ({ tourId, departureName }: DownloadManifestVariables) =>
      downloadManifestForDeparture(tourId, departureName),
  });
}
